import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'ms-avatar',
	templateUrl: './ms-avatar.component.html',
	styleUrls: ['./ms-avatar.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsAvatarComponent implements OnInit, OnDestroy {
	@Input() class: string;
	@Input() value: string;
	@Input() image: any;
	isLoading: boolean;
	isAvatarDefault: boolean;

	/**
	 * Constructor
	 */
	constructor() {
		this._reset();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (this.value === undefined || this.value === null) {
			this.value = '';
		}
		this._reset();
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this._reset();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	hideLoaderSuccess() {
		this.isLoading = false;
		this.isAvatarDefault = false;
	}

	hideLoaderError() {
		this.isLoading = false;
		this.isAvatarDefault = true;
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------

	_reset() {
		this.isLoading = true;
		this.isAvatarDefault = false;
	}
}
